import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import style from "./AddTracks.module.css";

import trackChanged from "../../redux/actionCreators/trackAdded";

import { callAPI } from "../../assets/Js/backendCommunication";

import { Spinner } from "../../Components/Spinner/Spinner";

import { getPlainToken } from "../../assets/Js/tokenHandler";

import projectSettings from "../../assets/Js/projectSettings";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

import { closeModel } from "../../assets/Js/closeModel";

import toTitleCase from "../../assets/Js/titleCase";

const trackTypes = {
  free: "free",
  private: "private",
  paid: "paid",
};

const mapDispatchToProps = (dispatch) => {
  return {
    trackChanged: () => dispatch(trackChanged()),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(
  class AddTracks extends Component {
    constructor(props) {
      super(props);

      this.trackNameRef = createRef();
      this.trackTypeRef = createRef();
      this.passwordRef = createRef();
      this.priceRef = createRef();
      this.FreeTrialRef = createRef();
      this.trackDescriptionRef = createRef();
      this.trackWelcomeNoteRef = createRef();

      this.state = {
        isLoading: false,
        data: {
          trackName: "",
          trackType: trackTypes.free,
          password: "",
          price: 1,
          NumberOfTrialDays: 0,
          description: "",
          welcomeNote: ""
        },
      };
    }

    componentDidMount() {
      let data = {
        trackName: this.props && this.props.track ? this.props.track.Name : "",
        trackType:
          this.props && this.props.track
            ? this.props.track.Type
            : trackTypes.free,
        password:
          this.props && this.props.track ? this.props.track.JoinPassword : "",
        price: this.props && this.props.track ? this.props.track.Price : 1,
        NumberOfTrialDays: this.props?.track?.TrialPeriodDays || 0,
        description: this.props?.track?.Description || "",
        welcomeNote: this.props?.track?.WelcomeNote || "",
      };
      this.setState({
        data: data,
      });
    }

    componentWillUnmount(){
      this.props.handleShowConnectWithStripeAlert(false);
    }

    submitHandler = (e) => {
      e.preventDefault();
      if (this.props.editableTrack) {
        this.updateTrack();
      } else {
        this.addNewTrack();
      }
    };

    updateTrack = async () => {
      let url = `${projectSettings.baseUrl}/tracks/update/${this.props.track.Id}`;
      let header = false;
      let type = "POST";
      let token = getPlainToken();
      let trackData = new FormData();

      trackData.append("Name", this.state.data.trackName);
      trackData.append("status", true);
      trackData.append("Type", this.state.data.trackType.toLowerCase());
      trackData.append("Description",this.state.data.description);
      trackData.append("WelcomeNote", this.state.data.welcomeNote);


      switch (this.state.data.trackType) {
        case trackTypes.free:
          break;
        case trackTypes.private:
        trackData.append("JoinPassword", this.state.data.password);
          break;
        case trackTypes.paid:
          trackData.append("Price", this.state.data.price);
          trackData.append("TrialPeriodDays", this.state.data.NumberOfTrialDays);
          break;
        default:
          break;
      }

      let response = "";

      if (response === "") {
        this.setState({ isLoading: true });
      }

      response = await callAPI(url, header, type, trackData, token);

      if (response) {
        apiResponseToast(response.status, "updateTrack", response.data.message);
        this.setState({ isLoading: false });
        if (response.type === "error") {
        } else if (response.type === "success") {
          this.setState({ showError: false });
          this.props.trackChanged();
          this.props.updateData();
          this.props.resetOnCloseModal();
          closeModel(this.props.modalId);
          response = "";
        }
      }
    };

    showConnectWithStripeAlertForPaidTracks = () => {
      this.props.handleShowConnectWithStripeAlert(true);
    };

    addNewTrack = async () => {
      this.props.handleShowConnectWithStripeAlert(false);
      let url = `${projectSettings.baseUrl}/tracks/create`;
      let header = false;
      let type = "POST";
      let token = getPlainToken();
      let trackData = new FormData();

      trackData.append("Name", this.state.data.trackName);
      trackData.append("status", true);
      trackData.append("Type", this.state.data.trackType.toLowerCase());
      trackData.append("Description",this.state.data.description);
      trackData.append("WelcomeNote", this.state.data.welcomeNote);


      switch (this.state.data.trackType) {
        case trackTypes.free:
          break;
        case trackTypes.private:
        trackData.append("JoinPassword", this.state.data.password);
          break;
        case trackTypes.paid:
          trackData.append("Price", this.state.data.price);
          trackData.append("TrialPeriodDays", this.state.data.NumberOfTrialDays);
          break;
        default:
          break;
      }

      let response = "";

      if (response === "") {
        this.setState({ isLoading: true });
      }

      response = await callAPI(url, header, type, trackData, token);

      if (response) {
        apiResponseToast(response.status, "addTrack", response.data.message);
        this.setState({ isLoading: false });
        if (response.type === "error") {
          if(response.data?.stripeError){
            this.props.resetOnCloseModal();
            closeModel(this.props.modalId);
            this.showConnectWithStripeAlertForPaidTracks();
          }
        } else if (response.type === "success") {
          this.setState({ showError: false });
          response = "";
          this.reset();
          this.props.trackChanged();
          this.props.resetOnCloseModal();
          closeModel(this.props.modalId);
        }
      }
    };

    reset = async () => {
      this.trackNameRef.current.value = "";
      this.trackTypeRef.current.value = "";
      this.trackDescriptionRef.current.value = "";
      this.trackWelcomeNoteRef.current.value = "";

      if (this.passwordRef && this.passwordRef.current) {
        this.passwordRef.current.value = "";
      }
      if (this.priceRef && this.priceRef.current) {
        this.priceRef.current.value = "";
      }

      await this.setState({
        isLoading: false,
        data: {
          trackName: "",
          trackType: trackTypes.free,
          password: "",
          price: 1,
          NumberOfTrialDays: 0,
        },
      });
    };

    typeChangerHandler = (value) => {
      if (value) {
        this.setState({
          data: { ...this.state.data, trackType: value },
        });
      }
    };

    savePasssowrd = (e) => {
      this.setState({
        data: { ...this.state.data, password: e.target.value },
      });
    };

    saveTrackPrice = (e) => {
      this.setState({
        data: { ...this.state.data, price: e.target.value },
      });
    };

    saveTrackType = (e) => {
      this.typeChangerHandler(e.target.value.toLowerCase());
    };

    saveTrackName = (e) => {
      this.setState({
        data: { ...this.state.data, trackName: e.target.value },
      });
    };

    saveFreeTrialNumber = (e) => {
      this.setState({
        data: {
          ...this.state.data,
          NumberOfTrialDays: parseInt(e.target.value),
        },
      });
    };

    saveTrackDesciption = (e) => {
      this.setState({
        data: {
          ...this.state.data,
          description: e.target.value,
        },
      });
    };

    saveTrackWelcomeNote = (e) => {
      this.setState({
        data: {
          ...this.state.data,
          welcomeNote: e.target.value,
        },
      });
    };

    render() {
      return (
        <div>
          <form
            className="forms-sample  pt-2 pb-1"
            onSubmit={(e) => this.submitHandler(e)}
          >
            <div className="formGroup">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                className="form-control form-control-sm"
                id="text"
                placeholder="Track Name"
                required
                ref={this.trackNameRef}
                defaultValue={this.state.data.trackName}
                onChange={this.saveTrackName}
              />
            </div>

            <div class="formGroup">
              <label for="exampleFormControlTextarea1">Description</label>
              <textarea
                class="form-control form-control-sm"
                id="exampleFormControlTextarea1"
                rows="3"
                placeholder="Your description should be less than 250 characters"
                required
                ref={this.trackDescriptionRef}
                defaultValue={this.state.data.description}
                maxLength={250}
                onChange={this.saveTrackDesciption}
              ></textarea>
            </div>

            <div class="formGroup">
              <label for="exampleFormControlTextarea1">Welcome Note</label>
              <textarea
                class="form-control form-control-sm"
                id="exampleFormControlTextarea1"
                rows="3"
                placeholder="Welcome to Cross Fit asimplify platform "
                required
                ref={this.trackWelcomeNoteRef}
                defaultValue={this.state.data.welcomeNote}
                maxLength={100}
                onChange={this.saveTrackWelcomeNote}
              ></textarea>
            </div>

            {this.state.data.trackType.toLowerCase() === trackTypes.paid && (
              <div className="formGroup">
                <label htmlFor="name">Trial Period Days</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  min={"0"}
                  id="numberFreeTrialDays"
                  value={this.state.data.NumberOfTrialDays}
                  onChange={this.saveFreeTrialNumber}
                />
              </div>
            )}

            <div className="formGroup">
              <label htmlFor="trackType">Type</label>
              <select
                className="form-control athleteGenderField"
                id="trackType"
                disabled={
                  this.props?.track?.Type.toLowerCase() === trackTypes.paid
                }
                value={this.state.data.trackType}
                ref={this.trackTypeRef}
                onChange={this.saveTrackType}
              >
                <option value={trackTypes.free}>
                  {toTitleCase(trackTypes.free)}
                </option>
                <option value={trackTypes.private}>
                  {toTitleCase(trackTypes.private)}
                </option>
                <option value={trackTypes.paid}>
                  {toTitleCase(trackTypes.paid)}
                </option>
              </select>
            </div>

            {this.state.data.trackType.toLowerCase() === trackTypes.private && (
              <div className="formGroup">
                <label htmlFor="password">Track Password</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="password"
                  placeholder="Password"
                  required
                  defaultValue={this.state.data.password}
                  ref={this.passwordRef}
                  onChange={this.savePasssowrd}
                />
              </div>
            )}

            {this.state.data.trackType.toLowerCase() === trackTypes.paid && (
              <div className="formGroup">
                <label htmlFor="price">Price/Month</label>
                <div className="d-flex input-group-sm">
                  <div className="input-group-prepend">
                    <span
                      className={`input-group-text ${style.signBox}`}
                      id="inputGroup-sizing-sm"
                    >
                      $
                    </span>
                  </div>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    id="phone"
                    placeholder="Price in dollars"
                    disabled={
                      this.props?.track?.Type.toLowerCase() === trackTypes.paid
                    }
                    maxlength="11"
                    min={"1"}
                    required
                    value={this.state.data.price}
                    ref={this.priceRef}
                    onChange={this.saveTrackPrice}
                  />
                </div>
              </div>
            )}

            <div className="d-flex justify-content-end align-items-center mt-4 mb-2">
              <button
                className={`basicFatBtnStyle quaternaryColor colorDark mr-2`}
                data-dismiss="modal"
                onClick={this.props.resetOnCloseModal}
              >
                Cancel
              </button>

              <button
                className="basicFatBtnStyle primaryBtn"
                type="submit"
                disabled={this.state.isLoading}
              >
                {this.state.isLoading ? (
                  <div>
                    <Spinner />
                  </div>
                ) : this.props.track ? (
                  <span>Update</span>
                ) : (
                  <span>Save</span>
                )}
              </button>
            </div>
          </form>
        </div>
      );
    }
  }
);
